//
//
//
//
//
//

import '@/assets/css/index.css'
export default {
  name: 'App',
  computed: {
    viewTransition () {
      return 'vux-pop-in'
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue